export interface EmbeddedSupplier {
	pictureUrl?: string;
	productName: string;
	supplierName: string;
	thumbnailKey: string;
}
